import React from 'react'

const MarkedText = ({ flag, children, classes='' }) => {
  const statusStyle = flag ? { backgroundColor: '#C4F1D8', color: '324467' } : { backgroundColor: '#FFE4E4', color: '#324467' }
  return (
    <span className={'inline-block font-semibold py-1 px-3 rounded-xl ' + classes} style={statusStyle}>
      {children}
    </span>
  )
}

export default MarkedText
